//------------- In this code is ready to deploy----------------------//

import React, { useState, useEffect } from "react";
import { get_employee_site_visits } from "./RestApiCalls";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowDown } from "@fortawesome/free-solid-svg-icons";
import Sidebar from "./Sidebar";

const monthNames = {
  January: 0,
  February: 1,
  March: 2,
  April: 3,
  May: 4,
  June: 5,
  July: 6,
  August: 7,
  September: 8,
  October: 9,
  November: 10,
  December: 11,
};

const getMonthDateRange = (monthName, year) => {
  const monthIndex = monthNames[monthName];
  const fromDate = new Date(year, monthIndex, 2);
  const toDate = new Date(year, monthIndex + 1, 1); // last day of month

  const format = (d) => d.toISOString().split("T")[0];

  return {
    fromDate: format(fromDate),
    toDate: format(toDate),
  };
};

const EmployeeData = ({ empId, empName, month, year }) => {
  const [siteVisitDetails, setSiteVisitDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [workingDays, setWorkingDays] = useState(0.0);
  const [holidays, setHolidays] = useState(0.0);
  const [absentDays, setAbsentDays] = useState(0.0);
  const [totalWorkingDays, settotalWorkingDays] = useState(0.0);

  const { fromDate, toDate } = getMonthDateRange(month, year);

  // Fetch and display data for the selected employee
  useEffect(() => {
    const fetchData = async () => {
      if (empId) {
        setLoading(true);
        const response = await get_employee_site_visits(
          empId,
          fromDate,
          toDate
        );
        if (response?.empAttList?.length > 0) {
          const filtered = response.empAttList.filter(
            (item) => item.attDate >= fromDate && item.attDate <= toDate
          );
          let workingDaysCount = 0.0;
          let totalWorkingDaysCount = 0.0;
          let holidayCount = 0.0;
          let absentCount = 0.0;
          setWorkingDays(workingDaysCount);
          filtered.forEach((entry) => {
            if (entry.attendance === "Filled") {
              setWorkingDays(++workingDaysCount);
            }
            if (entry.attendance === "Partial Fill") {
              workingDaysCount = workingDaysCount + 0.5;
              setWorkingDays(workingDaysCount);
            }
          });
          setSiteVisitDetails(filtered);
        } else {
          setSiteVisitDetails([]);
        }
        setLoading(false);
      }
    };
    fetchData();
  }, [empId, fromDate, toDate]);

  // Fetch all employees once for download
  useEffect(() => {
    fetch(
      "https://www.principleacs.net/LoginApi/public/getAllEmployeesForAttendance"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data?.empList) {
          setEmployees(data.empList);
        }
      });
  }, []);

  const downloadExcel = () => {
    const from = fromDate;
    const to = toDate;
    const downloadUrl = `https://principleacs.net/attendance_excel.php?from=${from}&to=${to}`;

    // Trigger browser download via anchor
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", `AllEmployees_${month}_${year}.xlsx`);
    link.target = "_blank"; // Optional: opens in new tab
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // 2nd code for download const downloadExcel = async () => {
  //   const from = fromDate;
  //   const to = toDate;

  //   const downloadUrl = `https://principleacs.net/attendance_excel.php?from=${from}&to=${to}`;

  //   try {
  //     const response = await fetch(downloadUrl);
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch Excel file.");
  //     }

  //     const blob = await response.blob();
  //     const fileName = `AllEmployees_${month}_${year}.xlsx`;
  //     saveAs(blob, fileName);
  //   } catch (error) {
  //     alert("Excel download failed. Please try again.");
  //     console.error("Download error:", error);
  //   }
  // };

  //1st one
  //  const downloadExcel = async () => {
  //   setLoading(true);
  //   const allData = [];

  //   for (const emp of employees) {
  //     try {
  //       const res = await get_employee_site_visits(emp.empId, fromDate, toDate);
  //       if (res?.empAttList?.length) {
  //         res.empAttList.forEach((entry) => {
  //           allData.push({
  //             EmployeeID: emp.empId,
  //             EmployeeName: emp.empName,
  //             Date: entry.attDate,
  //             Attendance: entry.attendance,
  //             "Login Type": entry.attLoginType,
  //             "Login Lat": entry.loginLatitude,
  //             "Login Time": entry.loginTime,
  //             "Login Long": entry.loginLongitude,
  //             "Logout Type": entry.attLogoutType,
  //             "Logout Time": entry.logoutTime,
  //             "Logout Lat": entry.logoutLatitude,
  //             "Logout Long": entry.logoutLongitude,
  //             Circle: entry.circle,
  //             Reason: entry.reason,
  //             "Work Hours": entry.workHours,
  //             "Holiday Type": entry.holidayType,
  //             "Holiday Circle": entry.holidayCircle,
  //           });
  //         });
  //       }
  //     } catch (err) {
  //       console.log("Failed for empId:", emp.empId, err);
  //     }
  //   }

  //   if (allData.length === 0) {
  //     alert("No data found for the selected month/year.");
  //     setLoading(false);
  //     return;
  //   }

  //   const worksheet = XLSX.utils.json_to_sheet(allData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "All_Employees");

  //   const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  //   const file = new Blob([buffer], { type: "application/octet-stream" });
  //   saveAs(file, `AllEmployees_${month}_${year}.xlsx`);
  //   setLoading(false);
  // };

  return (
    <div className="view-port-height">
      {/* <div className="download-excel-view" style={{ paddingBottom: "10px" }}>
        <button
          onClick={downloadExcel}
          disabled={loading}
          className="btn btn-primary"
        >
          <FontAwesomeIcon icon={faCloudArrowDown} />{" "}
          {loading ? "Downloading..." : "Download Excel"}
        </button>
      </div> */}

      {empId && (
        <>
          <h4>
            Employee Attendance for ID:<b> {empId}</b> Name:-<b>{empName}</b>{" "}
            Working Days:-
            <b>{workingDays}</b>
          </h4>
          {loading ? (
            <p>Loading employee data...</p>
          ) : siteVisitDetails.length > 0 ? (
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Attendance</th>
                  <th>Login Type</th>
                  <th>Login Time</th>
                  <th>Login Lat</th>
                  {/* <th>Login Time</th> */}
                  <th>Login Long</th>
                  <th>Logout Type</th>
                  <th>Logout Time</th>
                  <th>Logout Lat</th>
                  <th>Logout Long</th>
                  <th>Circle</th>
                  <th>Reason</th>
                  <th>Work Hours</th>
                  <th>Holiday Type</th>
                  <th>Holiday Circle</th>
                </tr>
              </thead>
              <tbody>
                {siteVisitDetails.map((row, index) => (
                  <tr key={index}>
                    <td>{row.attDate}</td>
                    <td>{row.attendance}</td>
                    <td>
                      {row.attendance === "Filled" &&
                      row.attLoginType === "Select"
                        ? "Site Visited"
                        : row.attLoginType === "Select"
                        ? "-"
                        : row.attLoginType}
                    </td>
                    <td>{row.loginTime}</td>
                    <td>{row.loginLatitude}</td>
                    {/* <td>{row.loginTime}</td> */}
                    <td>{row.loginLongitude}</td>
                    <td>
                      {row.attendance === "Filled" &&
                      row.attLogoutType === "Select"
                        ? "Site Visited"
                        : row.attLogoutType === "Select"
                        ? "-"
                        : row.attLogoutType}
                    </td>
                    <td>{row.logoutTime}</td>
                    <td>{row.logoutLatitude}</td>
                    <td>{row.logoutLongitude}</td>
                    <td>{row.circle}</td>
                    <td>{row.reason}</td>
                    <td>{row.workHours}</td>
                    <td>{row.holidayType}</td>
                    <td>{row.holidayCircle}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No data found for the selected employee and date range.</p>
          )}
        </>
      )}
    </div>
  );
};

export default EmployeeData;

//--------------------------------------perfect one (Default load dropdown is june) thats for below code -----------------------------------//

// import React, { useState, useEffect } from "react";
// import { get_employee_site_visits } from "./RestApiCalls";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const monthNames = {
//   January: 0,
//   February: 1,
//   March: 2,
//   April: 3,
//   May: 4,
//   June: 5,
//   July: 6,
//   August: 7,
//   September: 8,
//   October: 9,
//   November: 10,
//   December: 11,
// };

// const getMonthDateRange = (monthName, year) => {
//   const monthIndex = monthNames[monthName];
//   const fromDate = new Date(year, monthIndex, 1);
//   const toDate = new Date(year, monthIndex + 1, 0); // last day

//   const format = (d) => d.toISOString().split("T")[0];

//   return {
//     fromDate: format(fromDate),
//     toDate: format(toDate),
//   };
// };

// const EmployeeData = ({ empId, month, year }) => {
//   const [employees, setEmployees] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const { fromDate, toDate } = getMonthDateRange(month, year);

//   useEffect(() => {
//     fetch(
//       "https://www.principleacs.net/LoginApi/public/getAllEmployeesForAttendance"
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         if (data?.empList) {
//           setEmployees(data.empList);
//         }
//       });
//   }, []);

//   const downloadExcel = async () => {
//     setLoading(true);
//     const allData = [];

//     for (const emp of employees) {
//       try {
//         const res = await get_employee_site_visits(emp.empId, fromDate, toDate);
//         if (res?.empAttList?.length) {
//           res.empAttList.forEach((entry) => {
//             allData.push({
//               EmployeeID: emp.empId,
//               EmployeeName: emp.empName,
//               Date: entry.attDate,
//               Attendance: entry.attendance,
//               "Login Type": entry.attLoginType,
//               "Login Lat": entry.loginLatitude,
//               "Login Time": entry.loginTime,
//               "Login Long": entry.loginLongitude,
//               "Logout Type": entry.attLogoutType,
//               "Logout Time": entry.logoutTime,
//               "Logout Lat": entry.logoutLatitude,
//               "Logout Long": entry.logoutLongitude,
//               Circle: entry.circle,
//               Reason: entry.reason,
//               "Work Hours": entry.workHours,
//               "Holiday Type": entry.holidayType,
//               "Holiday Circle": entry.holidayCircle,
//             });
//           });
//         }
//       } catch (err) {
//         console.log("Failed for empId:", emp.empId, err);
//       }
//     }

//     if (allData.length === 0) {
//       alert("No data found for the selected month/year.");
//       setLoading(false);
//       return;
//     }

//     const worksheet = XLSX.utils.json_to_sheet(allData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "All_Employees");

//     const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const file = new Blob([buffer], { type: "application/octet-stream" });
//     saveAs(file, `AllEmployees_${month}_${year}.xlsx`);
//     setLoading(false);
//   };

//   return (
//     <div>
//       <button
//         onClick={downloadExcel}
//         disabled={loading}
//         className="btn btn-primary"
//       >
//         {loading ? "Downloading..." : "Download Excel"}
//       </button>
//     </div>
//   );
// };

// export default EmployeeData;

//-------------------------------------ok perfect----------------------------------------------------//

// import React, { useState, useEffect } from "react";
// import { get_employee_site_visits } from "./RestApiCalls";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCloudArrowDown } from "@fortawesome/free-solid-svg-icons";

// // const getPreviousMonthDateRange = () => {
// //   const now = new Date();
// //   const firstDay = new Date(now.getFullYear(), now.getMonth() - 1, 1);
// //   const lastDay = new Date(now.getFullYear(), now.getMonth(), 0);

// //   const formatDate = (date) => date.toISOString().split("T")[0];

// //   return {
// //     fromDate: formatDate(firstDay),
// //     toDate: formatDate(lastDay),
// //   };
// // };

// const getPreviousMonthDateRange = () => {
//   const now = new Date();
//   const year = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
//   const month = now.getMonth() === 0 ? 11 : now.getMonth() - 1;

//   const firstDay = new Date(year, month, 2);
//   const lastDay = new Date(year, month + 1, 1); // Auto calculates last day of month

//   const formatDate = (date) => date.toISOString().split("T")[0];

//   return {
//     fromDate: formatDate(firstDay),
//     toDate: formatDate(lastDay),
//   };
// };

// const EmployeeData = ({ empId }) => {
//   const [siteVisitDetails, setSiteVisitDetails] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const { fromDate, toDate } = getPreviousMonthDateRange();

//   useEffect(() => {
//     const fetchData = async () => {
//       if (empId) {
//         setLoading(true);
//         const response = await get_employee_site_visits(
//           empId,
//           fromDate,
//           toDate
//         );
//         if (response && response.empAttList) {
//           const filteredData = response.empAttList.filter((item) => {
//             return item.attDate >= fromDate && item.attDate <= toDate;
//           });
//           setSiteVisitDetails(filteredData);
//         }
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [empId, fromDate, toDate]);

//   const downloadExcel = () => {
//     if (siteVisitDetails.length === 0) {
//       alert("No data available to download");
//       return;
//     }

//     const worksheetData = siteVisitDetails.map((row) => ({
//       Date: row.attDate,
//       Attendance: row.attendance,
//       "Login Type": row.attLoginType,
//       "Login Latitude": row.loginLatitude,
//       "Login Time": row.loginTime,
//       "Login Longitude": row.loginLongitude,
//       "Logout Type": row.attLogoutType,
//       "Logout Time": row.logoutTime,
//       "Logout Latitude": row.logoutLatitude,
//       "Logout Longitude": row.logoutLongitude,
//       Circle: row.circle,
//       Reason: row.reason,
//       "Work Hours": row.workHours,
//       "Holiday Type": row.holidayType,
//       "Holiday Circle": row.holidayCircle,
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(worksheetData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "EmployeeData");

//     const excelBuffer = XLSX.write(workbook, {
//       bookType: "xlsx",
//       type: "array",
//     });

//     const fileData = new Blob([excelBuffer], {
//       type: "application/octet-stream",
//     });
//     saveAs(fileData, `EmployeeId_${empId}_${fromDate}_to_${toDate}.xlsx`);
//   };

//   if (!empId) return <div>Select an employee to view details</div>;
//   if (loading) return <div>Loading...</div>;

//   return (
//     <div>
//       <div className="download-excel-view">
//         <h4>Employee Attendance for ID: {empId}</h4>

//         <button
//           onClick={downloadExcel}
//           style={{ marginBottom: "10px" }}
//           className="btn btn-primary"
//         >
//           <FontAwesomeIcon icon={faCloudArrowDown} /> Download as Excel
//         </button>
//       </div>
//       <table className="table table-striped table-bordered">
//         <thead>
//           <tr>
//             <th>Date</th>
//             <th>Attendance</th>
//             <th>Login Type</th>
//             <th>Login Lat</th>
//             <th>Login Time</th>
//             <th>Login Long</th>
//             <th>Logout Type</th>
//             <th>Logout Time</th>
//             <th>Logout Lat</th>
//             <th>Logout Long</th>
//             <th>Circle</th>
//             <th>Reason</th>
//             <th>Work Hours</th>
//             <th>Holiday Type</th>
//             <th>Holiday Circle</th>
//           </tr>
//         </thead>
//         <tbody>
//           {siteVisitDetails.map((row, index) => (
//             <tr key={index}>
//               <td>{row.attDate}</td>
//               <td>{row.attendance}</td>
//               <td>{row.attLoginType}</td>
//               <td>{row.loginLatitude}</td>
//               <td>{row.loginTime}</td>
//               <td>{row.loginLongitude}</td>
//               <td>{row.attLogoutType}</td>
//               <td>{row.logoutTime}</td>
//               <td>{row.logoutLatitude}</td>
//               <td>{row.logoutLongitude}</td>
//               <td>{row.circle}</td>
//               <td>{row.reason}</td>
//               <td>{row.workHours}</td>
//               <td>{row.holidayType}</td>
//               <td>{row.holidayCircle}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default EmployeeData;

//----------------------------------------perfect code without dowload option-----------------------------------------------------------//

// import React, { useState, useEffect } from "react";
// import { get_employee_site_visits } from "./RestApiCalls";

// // Function to get previous month date range dynamically
// const getPreviousMonthDateRange = () => {
//   const now = new Date();
//   const year = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
//   const month = now.getMonth() === 0 ? 11 : now.getMonth() - 1;

//   const firstDay = new Date(year, month, 2);
//   const lastDay = new Date(year, month + 1, 1); // Auto calculates last day of month

//   const formatDate = (date) => date.toISOString().split("T")[0];

//   return {
//     fromDate: formatDate(firstDay),
//     toDate: formatDate(lastDay),
//   };
// };

// const EmployeeData = ({ empId }) => {
//   const [siteVisitDetails, setSiteVisitDetails] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const { fromDate, toDate } = getPreviousMonthDateRange();

//   useEffect(() => {
//     const fetchData = async () => {
//       if (empId) {
//         setLoading(true);
//         const response = await get_employee_site_visits(
//           empId,
//           fromDate,
//           toDate
//         );
//         if (response && response.empAttList) {
//           const filteredData = response.empAttList.filter((item) => {
//             return item.attDate >= fromDate && item.attDate <= toDate;
//           });

//           setSiteVisitDetails(filteredData);
//         } else {
//           setSiteVisitDetails([]);
//         }
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [empId, fromDate, toDate]);

//   if (!empId) return <div>Select an employee to view details</div>;
//   if (loading) return <div>Loading...</div>;

//   return (
//     <div>
//       <h2>Employee Attendance for ID: {empId}</h2>
//       <table className="table table-striped table-bordered">
//         <thead>
//           <tr>
//             <th>Date</th>
//             <th>Attendance</th>
//             <th>Login Type</th>
//             <th>Login Lat</th>
//             <th>Login Time</th>
//             <th>Login Long</th>
//             <th>Logout Type</th>
//             <th>Logout Time</th>
//             <th>Logout Lat</th>
//             <th>Logout Long</th>
//             <th>Circle</th>
//             <th>Reason</th>
//             <th>Work Hours</th>
//             <th>Holiday Type</th>
//             <th>Holiday Circle</th>
//           </tr>
//         </thead>
//         <tbody>
//           {siteVisitDetails.length === 0 ? (
//             <tr>
//               <td colSpan="15">No attendance data found for this employee.</td>
//             </tr>
//           ) : (
//             siteVisitDetails.map((row, index) => (
//               <tr key={index}>
//                 <td>{row.attDate}</td>
//                 <td>{row.attendance}</td>
//                 <td>{row.attLoginType}</td>
//                 <td>{row.loginLatitude}</td>
//                 <td>{row.loginTime}</td>
//                 <td>{row.loginLongitude}</td>
//                 <td>{row.attLogoutType}</td>
//                 <td>{row.logoutTime}</td>
//                 <td>{row.logoutLatitude}</td>
//                 <td>{row.logoutLongitude}</td>
//                 <td>{row.circle}</td>
//                 <td>{row.reason}</td>
//                 <td>{row.workHours}</td>
//                 <td>{row.holidayType}</td>
//                 <td>{row.holidayCircle}</td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default EmployeeData;

//---------------------------------------------------------------------------------------------------//

// import React, { useState, useEffect } from "react";
// import { get_employee_site_visits } from "./RestApiCalls";

// const getPreviousMonthDateRange = () => {
//   const now = new Date();
//   const firstDay = new Date(now.getFullYear(), now.getMonth() - 1, 1);
//   const lastDay = new Date(now.getFullYear(), now.getMonth(), 0);

//   const formatDate = (date) => date.toISOString().split("T")[0];

//   return {
//     fromDate: formatDate(firstDay),
//     toDate: formatDate(lastDay),
//   };
// };

// const EmployeeData = ({ empId }) => {
//   const [siteVisitDetails, setSiteVisitDetails] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const { fromDate, toDate } = getPreviousMonthDateRange();

//   useEffect(() => {
//     const fetchData = async () => {
//       if (empId) {
//         setLoading(true);
//         const response = await get_employee_site_visits(
//           empId,
//           fromDate,
//           toDate
//         );
//         if (response && response.empAttList) {
//           setSiteVisitDetails(response.empAttList);
//         }
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [empId, fromDate, toDate]);

//   if (!empId) return <div>Select an employee to view details</div>;
//   if (loading) return <div>Loading...</div>;

//   return (
//     <div>
//       <h2>Employee Attendance for ID: {empId}</h2>
//       <table className="table table-striped table-bordered">
//         <thead>
//           <tr>
//             <th>Date</th>
//             <th>Attendance</th>
//             <th>Login Type</th>
//             <th>Login Lat</th>
//             <th>Login Time</th>
//             <th>Login Long</th>
//             <th>Logout Type</th>
//             <th>Logout Time</th>
//             <th>Logout Lat</th>
//             <th>Logout Long</th>
//             <th>Circle</th>
//             <th>Reason</th>
//             <th>Work Hours</th>
//             <th>Holiday Type</th>
//             <th>Holiday Circle</th>
//           </tr>
//         </thead>
//         <tbody>
//           {siteVisitDetails.map((row, index) => (
//             <tr key={index}>
//               <td>{row.attDate}</td>
//               <td>{row.attendance}</td>
//               <td>{row.attLoginType}</td>
//               <td>{row.loginLatitude}</td>
//               <td>{row.loginTime}</td>
//               <td>{row.loginLongitude}</td>
//               <td>{row.attLogoutType}</td>
//               <td>{row.logoutTime}</td>
//               <td>{row.logoutLatitude}</td>
//               <td>{row.logoutLongitude}</td>
//               <td>{row.circle}</td>
//               <td>{row.reason}</td>
//               <td>{row.workHours}</td>
//               <td>{row.holidayType}</td>
//               <td>{row.holidayCircle}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default EmployeeData;

//-----------------------------------------------------------------------------------------------------//

// import React, { useState, useEffect } from "react";
// import { get_employee_site_visits } from "./RestApiCalls";

// const EmployeeData = ({ empId }) => {
//   const [siteVisitDetails, setSiteVisitDetails] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const { fromDate, toDate } = getPreviousMonthDateRange();

//   //--------------------------------------------------------------------------//

//   const getPreviousMonthDateRange = () => {
//     const now = new Date();
//     const firstDay = new Date(now.getFullYear(), now.getMonth() - 1, 1);
//     const lastDay = new Date(now.getFullYear(), now.getMonth(), 0);

//     const formatDate = (date) => date.toISOString().split("T")[0];

//     return {
//       fromDate: formatDate(firstDay),
//       toDate: formatDate(lastDay),
//     };
//   };

//   //--------------------------------------------------------------------------//

//   useEffect(() => {
//     const fetchData = async () => {
//       if (empId) {
//         setLoading(true);
//         const response = await get_employee_site_visits(
//           empId,
//           fromDate,
//           toDate
//         );
//         if (response && response.empAttList) {
//           setSiteVisitDetails(response.empAttList);
//         }
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [empId]);

//   if (!empId) return <div>Select an employee to view details</div>;
//   if (loading) return <div>Loading...</div>;

//   return (
//     <div>
//       <h2>Employee Attendance for ID: {empId}</h2>
//       <table className="table table-striped table-bordered">
//         <thead>
//           <tr>
//             <th>Date</th>
//             <th>Attendance</th>
//             <th>Login Type</th>
//             <th>Login Lat</th>
//             <th>Login Time</th>
//             <th>Login Long</th>
//             <th>Logout Type</th>
//             <th>Logout Time</th>
//             <th>Logout Lat</th>
//             <th>Logout Long</th>
//             <th>Circle</th>
//             <th>Reason</th>
//             <th>Work Hours</th>
//             <th>Holiday Type</th>
//             <th>Holiday Circle</th>
//           </tr>
//         </thead>
//         <tbody>
//           {siteVisitDetails.map((row, index) => (
//             <tr key={index}>
//               <td>{row.attDate}</td>
//               <td>{row.attendance}</td>
//               <td>{row.attLoginType}</td>
//               <td>{row.loginLatitude}</td>
//               <td>{row.loginTime}</td>
//               <td>{row.loginLongitude}</td>
//               <td>{row.attLogoutType}</td>
//               <td>{row.logoutTime}</td>
//               <td>{row.logoutLatitude}</td>
//               <td>{row.logoutLongitude}</td>
//               <td>{row.circle}</td>
//               <td>{row.reason}</td>
//               <td>{row.workHours}</td>
//               <td>{row.holidayType}</td>
//               <td>{row.holidayCircle}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default EmployeeData;

//-----------------------------------------------perfect-------------------------------------------//
// import React, { useState } from "react";
// import { get_employee_site_visits, submit_new_calims } from "./RestApiCalls";
// import "./ExcelTable.css";
// import profile from "../assets/account.png";
// import searchIcon from "../assets/searchIcon.png";
// import addImg from "../assets/add.png";
// import locationImg from "../assets/rotate.png";

// const EmployeeData = () => {
//   const [siteVisitDetails, setSiteVisitDetails] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [validationError, setValidationError] = useState([]);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [fromDate, setFromDate] = useState(""); // New state for from_date
//   const [toDate, setToDate] = useState(""); // New state for to_date

//   const handleSearchChange = (e) => setSearchTerm(e.target.value);

//   //------------------------------------------------------------------------------//
//   const [tableData, setTableData] = useState([]);

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [isEditMode, setIsEditMode] = useState(false);

//   const [addVisitFieldInputs, setAddVisitFieldInputs] = useState([""]);
//   const [addLatFieldInputs, setAddLatFieldInputs] = useState([""]);
//   const [addLongFieldInputs, setAddLongFieldInputs] = useState([""]);
//   const [addDateInputs, setAddDateInputs] = useState("");
//   const [isAddOpen, setIsAddOpen] = useState(false);
//   const [isAddButtonShow, setIsAddButtonShow] = useState(siteVisitDetails > 0);

//   const handleEditRow = (row) => {
//     setSelectedRow({ ...row }); // Edit mode, retain current S_NO
//     setIsEditMode(true); // Edit mode
//     setIsModalOpen(true);
//   };

//   const handleCopyRow = (row) => {
//     setSelectedRow({ ...row, id: row.id + 1 }); // Duplicate row with new S_NO
//     setIsModalOpen(true);
//     setIsEditMode(false); // Copy mode
//   };

//   const handleDeleteRow = (index) => {
//     const updatedData = siteVisitDetails.filter((row) => row.id !== index);
//     setSiteVisitDetails(updatedData);
//     setTableData(siteVisitDetails);
//   };

//   const handleDirections = (claimInfo) => {
//     const mapUrl =
//       "https://www.google.com/maps/dir/" +
//       claimInfo.userLat +
//       "," +
//       claimInfo.userLng +
//       "/" +
//       claimInfo.siteIdLatitude +
//       "," +
//       claimInfo.siteIdLongitude +
//       "/data=!3m1!4b1!4m10!4m9!1m3!2m2!1d72.6003229!2d23.0268102!1m3!2m2!1d72.38275!2d22.86098!3e0";
//     window.open(mapUrl, "_blank", "noopener,noreferrer");
//   };

//   // Handle input changes in the modal
//   const handleModalInputChange = (field, value) => {
//     setSelectedRow((prevRow) => ({
//       ...prevRow,
//       [field]: value,
//     }));
//   };

//   // Save changes (Copy or Edit)
//   const handleSave = () => {
//     if (isEditMode) {
//       // Edit existing row

//       setSiteVisitDetails((siteVisitDetails) =>
//         siteVisitDetails.map((row) =>
//           row.id === selectedRow.id ? selectedRow : row
//         )
//       );
//       //   setSiteVisitDetails((siteVisitDetails) =>
//       //     siteVisitDetails.map((row) =>
//       //       row.rowIndex === selectedRow.rowIndex ? selectedRow : row
//       //     )
//       //   );

//       setTableData(siteVisitDetails);
//     } else {
//       // Add new copied row
//       setSiteVisitDetails([
//         ...siteVisitDetails.slice(0, selectedRow.id),
//         selectedRow,
//         ...siteVisitDetails.slice(selectedRow.id),
//       ]);
//       setTableData(siteVisitDetails);
//     }
//     setIsModalOpen(false);
//     setSelectedRow(null);
//   };
//   // Close modal without saving
//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedRow(null);
//   };

//   const handleAddbtn = () => {
//     setIsAddOpen(true);
//     if (siteVisitDetails.length > 0) {
//       addVisitFieldInputs[0] =
//         siteVisitDetails[siteVisitDetails.length - 1].siteId;
//       addLatFieldInputs[0] =
//         siteVisitDetails[siteVisitDetails.length - 1].siteIdLatitude;
//       addLongFieldInputs[0] =
//         siteVisitDetails[siteVisitDetails.length - 1].siteIdLongitude;
//     }
//   };

//   const addInputField = () => {
//     setAddVisitFieldInputs([...addVisitFieldInputs, ""]);
//     setAddLatFieldInputs([...addLatFieldInputs, ""]);
//     setAddLongFieldInputs([...addLongFieldInputs, ""]);
//   };

//   //------------------------------------//
//   const removeInputField = () => {
//     setAddVisitFieldInputs((prev) => prev.slice(0, -1));
//     setAddLatFieldInputs((prev) => prev.slice(0, -1));
//     setAddLongFieldInputs((prev) => prev.slice(0, -1));
//   };

//   //---------------------------------//
//   const addCancel = () => {
//     setIsAddOpen(false);
//   };
//   //---------------------------------------------------------------------------------------------------------//
//   //
//   //

//   ///

//   const addSave = (e) => {
//     if (addDateInputs === "") {
//       alert("Select the date");
//       return;
//     }

//     // Check if all site visit fields are filled
//     for (let i = 0; i < addVisitFieldInputs.length; i++) {
//       if (
//         addVisitFieldInputs[i].trim() === "" ||
//         addLatFieldInputs[i].trim() === "" ||
//         addLongFieldInputs[i].trim() === ""
//       ) {
//         setValidationError("All fields are required.");
//         return;
//       }
//     }

//     // Clear validation error if all checks pass
//     setValidationError("");

//     //---------------------------------------------------------------------------------------------//
//     const valueObj = { ...siteVisitDetails[siteVisitDetails.length - 1] };
//     let newList = [];
//     addVisitFieldInputs.map((field, index) => {
//       // count++;
//       if (index < addVisitFieldInputs.length) {
//         valueObj.siteVisitDate = addDateInputs;
//         valueObj.buttonStatus = "Add";
//         valueObj.distance = "0.00";
//         if (index === 0) {
//           valueObj.userAddress = field;
//           valueObj.fta = `${0}`;
//           valueObj.userLat = addLatFieldInputs[index];
//           valueObj.userLng = addLongFieldInputs[index];
//           valueObj.siteVisitOrder = `${newList.length + 1}`;
//           valueObj.siteId = addVisitFieldInputs[index + 1];
//           valueObj.siteIdLatitude = addLatFieldInputs[index + 1];
//           valueObj.siteIdLongitude = addLongFieldInputs[index + 1];
//           newList.push({ ...valueObj });
//         } else if (index === addVisitFieldInputs.length - 1) {
//           // valueObj.userAddress = addVisitFieldInputs[index - 1];
//           // valueObj.userLat = addLatFieldInputs[index - 1];
//           // valueObj.userLng = addLongFieldInputs[index - 1];
//           // valueObj.siteVisitOrder = `${count}`;
//           // valueObj.siteId = addVisitFieldInputs[index];
//           // valueObj.siteIdLatitude = addLatFieldInputs[index];
//           // valueObj.siteIdLongitude = addLongFieldInputs[index];
//           // newList.push({ ...valueObj });
//           valueObj.fta = `${0}`;
//         } else {
//           valueObj.userAddress = field;
//           valueObj.userLat = addLatFieldInputs[index];
//           valueObj.userLng = addLongFieldInputs[index];
//           valueObj.siteVisitOrder = `${newList.length + 1}`;
//           valueObj.siteId = addVisitFieldInputs[index + 1];
//           if (index === addVisitFieldInputs.length - 2) {
//             valueObj.fta = `${0}`;
//           } else {
//             valueObj.fta = `${100}`;
//           }
//           valueObj.siteIdLatitude = addLatFieldInputs[index + 1];
//           valueObj.siteIdLongitude = addLongFieldInputs[index + 1];
//           newList.push({ ...valueObj });
//         }
//       }
//     });
//     setSiteVisitDetails([...siteVisitDetails, ...newList]);
//     setIsAddOpen(false);
//   };

//   const handleVisitInput = (index, event) => {
//     const valueList = [...addVisitFieldInputs];
//     valueList[index] = event.target.value;
//     setAddVisitFieldInputs(valueList);

//     // if (!event.target.value === "") {
//     //   setValidationError("enter the value");
//     // } else {
//     //   setValidationError("");
//     // }
//   };

//   const handleVisitInputLat = (index, event) => {
//     const valueList = [...addLatFieldInputs];
//     valueList[index] = event.target.value;
//     setAddLatFieldInputs(valueList);
//   };

//   const handleVisitInputLong = (index, event) => {
//     const valueList = [...addLongFieldInputs];
//     valueList[index] = event.target.value;
//     setAddLongFieldInputs(valueList);
//   };

//   const handleDateInput = (event) => {
//     setAddDateInputs(event.target.value);
//   };

//   const handleValidateButton = () => {};

//   const handleNewClaimAddButton = async (claimInfo, index) => {
//     try {
//       //
//       // const newClaimInfo = { ...claimInfo };
//       // newClaimInfo.distance = parseFloat(newClaimInfo.distance);
//       // newClaimInfo.fta = parseFloat("10.24");
//       // newClaimInfo.siteVisitOrder = Number(newClaimInfo.siteVisitOrder);
//       // newClaimInfo.empId = Number(newClaimInfo.empId);
//       console.log(claimInfo);
//       const response = await submit_new_calims(claimInfo);
//       console.log(response);
//       if (!response.error) {
//         const valueList = [...siteVisitDetails];
//         valueList[index].buttonStatus = "Update";
//         setSiteVisitDetails(valueList);
//       } else {
//         setError("Error fetching site visit details");
//       }
//     } catch (error) {}
//   };

//   const handleExistingClaimsUpdateButton = () => {};

//   const handleDeleteSubmitedClaimButton = () => {};

//   const handleDistanceOnChange = (index, value) => {
//     const valueList = [...siteVisitDetails];
//     valueList[index].distance = value;
//     setSiteVisitDetails(valueList);
//     // siteVisitDetails[index] = value;
//   };

//   //------------------------------------------------------------------------------//

//   const handleFetchSiteVisitDetails = async () => {
//     if (!fromDate || !toDate) {
//       alert("Please select both From Date and To Date.");
//       return;
//     } else {
//       alert(`${fromDate}  ${toDate}`);
//     }
//     setLoading(true);
//     try {
//       const response = await get_employee_site_visits(
//         searchTerm,
//         fromDate,
//         toDate
//       );
//       if (!response.error) {
//         setSiteVisitDetails(response.empAttList || []);
//       } else {
//         setError("Error fetching site visit details");
//       }
//       // setIsAddButtonShow(response.empAttList.length > 0);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="excel-table">
//       {/* Search Bar */}
//       <div className="search-bar">
//         <div className="nav-bar">
//           <img className="profile-dimensions" src={profile} alt="profile" />
//           <input
//             className="employee-search"
//             type="text"
//             placeholder="Search by Employee ID"
//             value={searchTerm}
//             onChange={handleSearchChange}
//           />
//           {/* Date Pickers */}
//           <input
//             className="date-picker"
//             type="date"
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//           />
//           <input
//             className="date-picker"
//             type="date"
//             value={toDate}
//             onChange={(e) => setToDate(e.target.value)}
//           />
//           {/* <button onClick={handleFetchSiteVisitDetails}> */}
//           <img
//             onClick={handleFetchSiteVisitDetails}
//             className="seach-icon"
//             src={searchIcon}
//             alt="search"
//           />
//           {/* <h3 className="heading">Add Manual Claim:</h3> */}
//           <img
//             className="addImg"
//             style={{ visibility: isAddButtonShow ? "visible" : "hidden" }}
//             onClick={handleAddbtn}
//             src={addImg}
//             alt="add"
//           />

//           {/* <button
//             style={{ visibility: isAddButtonShow ? "visible" : "hidden" }}
//             onClick={handleAddbtn}
//           >
//             add+
//           </button> */}

//           {/* </button> */}
//         </div>
//       </div>

//       {/* Table */}
//       <table className="table table-striped">
//         <thead>
//           <tr>
//             <th>date</th>
//             <th>attendance</th>
//             <th>attLoginType</th>
//             <th>loginLatitude</th>
//             <th>loginTime</th>
//             <th>loginLongitude</th>
//             <th>attLogoutType</th>
//             <th>logoutTime</th>
//             <th>logoutLatitude</th>
//             <th>logoutLongitude</th>
//             <th>circle</th>
//             <th>reason</th>
//             <th>workHours</th>
//             <th>holidayType</th>
//             <th>holidayCircle</th>
//           </tr>
//         </thead>
//         <tbody>
//           {siteVisitDetails.map((row, date) => (
//             <tr key={date}>
//               {/* <td>{row.id}</td> */}
//               {/* <td>{row.date}</td> */}
//               <td>{row.attDate}</td>
//               <td>{row.attendance}</td>
//               <td>{row.attLoginType}</td>
//               <td>{row.loginLatitude}</td>
//               <td>{row.loginTime}</td>
//               <td>{row.loginLongitude}</td>
//               <td>{row.attLogoutType}</td>
//               <td>{row.logoutTime}</td>
//               <td>{row.logoutLatitude}</td>
//               <td>{row.logoutLongitude}</td>
//               <td>{row.circle}</td>
//               <td>{row.reason}</td>
//               <td>{row.workHours}</td>
//               <td>{row.holidayType}</td>
//               <td>{row.holidayCircle}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>

//     //---------------------------------------------------//

//     //---------------------------------------------------//
//   );
// };

// export default EmployeeData;
